import { useMemo } from 'react';
import { getOverrideLocaleParam } from '../utils/getPreferredLanguage';
export function useIsOverrideLocaleActive() {
  return useMemo(() => Boolean(getOverrideLocaleParam()), []);
}